import { App } from 'vue'
export const setupComponents = (app: App) => {
  const requireContext = require.context(
    '/src/components/global',
    true,
    /\.vue$/
  )
  requireContext.keys().forEach(comp => {
    const vueComp = requireContext(comp)
    //使用正则中的组 第一个参数是匹配到的 使第二个参数为组中的即组件名称
    const regArray = /\/([\w-]+)\.vue$/.exec(comp)
    if (regArray && regArray.length > 1) {
      const regName = regArray[1]
      const compName = vueComp.default.name ? vueComp.default.name : regName
      app.component(compName, vueComp.default)
    }
  })
}
